import { render, staticRenderFns } from "./dashboardDonationUnit.vue?vue&type=template&id=42325544&scoped=true&"
import script from "./dashboardDonationUnit.vue?vue&type=script&lang=js&"
export * from "./dashboardDonationUnit.vue?vue&type=script&lang=js&"
import style0 from "./dashboardDonationUnit.vue?vue&type=style&index=0&id=42325544&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42325544",
  null
  
)

export default component.exports